import Image, { type ImageProps } from 'next/image';

import aiiaPatternImage from '@commons/assets/textures/aiia-pattern.jpg';

// Type definition for the AiiAPattern component.

type Props = Partial<ImageProps> & {
  alt: string;
};

/**
 * AiiAPattern component.
 */

const AiiAPattern = ({ alt, ...props }: Props) => (
  <Image src={aiiaPatternImage} alt={alt} {...props} />
);

export default AiiAPattern;
